import { Injectable, inject } from '@angular/core';
import { SessionStorage, SessionStorageService, SignalStateProperty } from '@mwe/utils';
import { Address, Product, createAddress } from '@mwe/models';
import { ProductsWhiteListLogic } from '../products-white-list.logic';

const PRODUCT_BILL_INFO_PRODUCTS_KEY = 'productBillInfo_products';
const PRODUCT_BILL_INFO_ADDRESS_KEY = 'productBillInfo_address';
const DIRECT_ADDRESS_SELECTION_KEY = 'direct_address_selection_key';

@Injectable({
  providedIn: 'root',
})
export class ProductBillInfoStateService {
  private storage = inject(SessionStorageService);
  private productsWhiteListLogic = inject(ProductsWhiteListLogic);

  @SessionStorage(PRODUCT_BILL_INFO_PRODUCTS_KEY)
  private _products: Product[];

  get products(): Product[] {
    return this._products;
  }

  set products(products: Product[]) {
    this._products = this.productsWhiteListLogic.removeNotWhiteListedProducts(products);
  }

  @SessionStorage(PRODUCT_BILL_INFO_ADDRESS_KEY)
  private _address: Address;

  get address(): Address {
    if (!this._address) {
      return undefined;
    }

    return createAddress(this._address);
  }

  set address(address: Address) {
    this._address = address;
  }

  @SessionStorage(DIRECT_ADDRESS_SELECTION_KEY)
  private _billinfoDirectAddressSelection: boolean;

  @SignalStateProperty()
  get directAddressSelection(): boolean {
    return this._billinfoDirectAddressSelection;
  }

  set directAddressSelection(isDirectAddressSelection: boolean) {
    this._billinfoDirectAddressSelection = isDirectAddressSelection;
  }

  clearData(): void {
    this.storage.clear(PRODUCT_BILL_INFO_PRODUCTS_KEY);
    this.storage.clear(PRODUCT_BILL_INFO_ADDRESS_KEY);
    this.storage.clear(DIRECT_ADDRESS_SELECTION_KEY);
  }
}
